import data from "./carModelData";
import style from "./carModel.css";

const kzs = window.kzs;
const $ = kzs.$;

export const changeCarModel = (): void => {
  style.use();

  // 価格表示
  setCarPrice();

  // ラインアップの高さ調整
  setLineupLayout();
};

export const getCarModelKey = (imgSrc: string): string => {
  return imgSrc.split("lineup-")[1].split(".jpg")[0].split(".png")[0];
};

const setCarPrice = (): void => {
  // 価格表示
  $(".l-lineup a.item").each((_i, e) => {
    const $item = $(e);
    const $img = $item.find("img");

    const imgSrc = $img.attr("src") == undefined ? "" : $img.attr("src");
    if (!imgSrc) return;

    const carModel = data.filter((e) => imgSrc.indexOf(e.imgSrc) > -1)[0];
    if (!carModel) return;

    console.log(carModel);

    $item.append($("<div>").addClass("kz-car-price").text(`${carModel.price}`));
  });
};

const setLineupLayout = (): void => {
  // 高さ調整（元ソース上書き）
  $(".lineup-tab.tabFst .child").on("click", (e) => {
    const stateTab = $(e.target).attr("data-category");
    const stateTab2 = $(".lineup-tab.tabSec .is-active").attr("data-category");
    console.log("tabOK");
    if (stateTab == "乗用車" && stateTab2 == "モデル一覧") {
      // $(".lineup-model-wrap").css("height", "calc(95vw + 105px)");
    } else if (stateTab == "STI Sport") {
      // $(".lineup-body-wrap").css("height", "calc(95vw + 105px)");
    } else if (stateTab == "軽自動車") {
      // $(".lineup-body-wrap").css("height", "calc(100vw + 105px)");
      $(".lineup-body-wrap").css("height", "calc(100vw + 105px + 64px)");
    }
  });

  $(".lineup-tab.tabSec .child").on("click", (e) => {
    const stateTab2 = $(".lineup-tab.tabSec .is-active").attr("data-category");

    if (stateTab2 == "ボディタイプ") {
      // $(".lineup-model-wrap, .lineup-body-wrap").css("height", "calc(100vw + 105px");
      $(".lineup-model-wrap, .lineup-body-wrap").css("height", "calc(100vw + 105px + 64px)");
    } else {
      // $(".lineup-model-wrap, .lineup-body-wrap").removeClass("is-open");
      // $(".lineup-model-wrap, .lineup-body-wrap").css("height", "calc(95vw + 105px");
    }
  });

  $(".lineup-model-inner .acrd_open, .lineup-body-inner .acrd_open").on("click", (e) => {
    $(e.target).closest(".lineup-model-wrap, .lineup-body-wrap").addClass("is-open");
    const stateTab = $(".lineup-tab.tabFst .is-active").attr("data-category");
    const stateTab2 = $(".lineup-tab.tabSec .is-active").attr("data-category");
    if (stateTab == "乗用車" && stateTab2 == "モデル一覧") {
      // $(".lineup-model-wrap.is-open").css("height", "calc(224vw + 20px)");
      $(".lineup-model-wrap.is-open").css("height", "calc(224vw + 20px + 108px)");
    } else if (stateTab == "乗用車" && stateTab2 == "ボディタイプ") {
      // $(".lineup-body-wrap.is-open").css("height", "calc(256vw + 20px)");
      $(".lineup-body-wrap.is-open").css("height", "calc(256vw + 20px + 96px)");
    }
    if (stateTab == "軽自動車") {
      // $(".lineup-body-wrap.is-open").css("height", "calc(170vw + 20px)");
      $(".lineup-body-wrap.is-open").css("height", "calc(170vw + 20px + 54px)");
    }
  });

  $(".lineup-tab .child").on("click", (e) => {
    const stateTab = $(".lineup-tab.tabFst .is-active").attr("data-category");
    const stateTab2 = $(".lineup-tab.tabSec .is-active").attr("data-category");

    $(".lineup-model-wrap, .lineup-body-wrap").removeClass("is-open");

    if (stateTab == "乗用車" && stateTab2 == "モデル一覧") {
      // $(".lineup-model-wrap, .lineup-body-wrap").css("height", "calc(118vw + 20px");
      $(".lineup-model-wrap, .lineup-body-wrap").css("height", "calc(118vw + 20px + 42px");
    } else if (stateTab == "乗用車" && stateTab2 == "ボディタイプ") {
      // $(".lineup-model-wrap, .lineup-body-wrap").css("height", "calc(118vw + 40px");
      $(".lineup-model-wrap, .lineup-body-wrap").css("height", "calc(118vw + 40px + 42px");
    } else if (stateTab == "STI Sport") {
      // $(".lineup-model-wrap, .lineup-body-wrap").css("height", "calc(90vw + 20px");
      $(".lineup-model-wrap, .lineup-body-wrap").css("height", "calc(90vw + 20px + 32px)");
    } else if (stateTab == "軽自動車") {
      // $(".lineup-model-wrap, .lineup-body-wrap").css("height", "calc(120vw + 40px");
      $(".lineup-model-wrap, .lineup-body-wrap").css("height", "calc(120vw + 40px + 56px)");
    }
  });
};
